import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
// components
import UserList from './UserList/UserList';
import UserTable from './UserList/UserTable';
import ManageUser from './ManageUser/ManageUser';
// css
import './User.scss';

class User extends Component {
	constructor(props) {
		super(props);
		this.state = {
			toggleView: true,
			userModal: false,
			title: '',
			userId: '',
			userDetails: {
				firstname: '',
				lastname: '',
				email: '',
				phone: '',
				country: '',
				city: ''
			},
			errorUserDetails: {
				firstname: true,
				lastname: true,
				email: true
			}
		}
		this.manageUser = this.manageUser.bind(this);
		this.confirmUserAction = this.confirmUserAction.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		const { } = this.state;
		const { userContext } = this.props;

		userContext.getUserList(1, 25);
	}

	componentWillUnMount() {
		this.props.userContext.clearUserList();
		this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { userDetails: { firstname, lastname, email, phone, country, city } } = nextProps.userContext;

		if (title === 'edit') {
			this.setState({
				userDetails: { firstname, lastname, email, phone, country, city },
				errorUserDetails: {
					firstname: !firstname || firstname === '',
					lastname: !lastname || lastname === '',
					email: !email || email === ''
				}
			});
		}
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.userContext.getUserList(curr_page, size);
	}

	// Modal (user_module)

	// open Modal (user_module)
	manageUser = (value, title = null, user_id = null) => {
		const { getUserDetails } = this.props.userContext;
		if (value) {
			if (title === 'edit') {
				getUserDetails(user_id);
			} else {
				this.setState({
					userDetails: {
						firstname: '',
						lastname: '',
						email: '',
						phone: '',
						country: '',
						city: ''
					},
					errorUserDetails: {
						firstname: true,
						lastname: true,
						email: true
					}
				});
			}
		} else {
			this.setState({
				userDetails: {
					firstname: '',
					lastname: '',
					email: '',
					phone: '',
					country: '',
					city: ''
				},
				errorUserDetails: {
					firstname: true,
					lastname: true,
					email: true
				}
			});
		}
		this.setState({
			userId: user_id,
			userModal: value,
			title
		});
	}

	// modal onchange fields (user_module)
	onChange = (e, val) => {
		this.setState({
			userDetails: {
				...this.state.userDetails,
				[e.target.name]: e.target.value
			},
			errorUserDetails: {
				...this.state.errorUserDetails,
				[e.target.name]: val
			}
		});
	}

	confirmUserAction = () => {
		const { title, userDetails, userId } = this.state;
		const { updateUserDetails, deleteUser, addUser } = this.props.userContext;

		if (title === 'edit') {
			updateUserDetails(userDetails, userId);
		} else if (title === 'add') {
			addUser(userDetails);
		} else if (title === 'delete') {
			deleteUser(userId);
		}
	}

	onToggle = () => {
		this.setState({
			...this.state,
			toggleView: !this.state.toggleView
		});
	}

	onDisable = (ers) => {
		const value = Object.keys(ers).some(val => ers[val] === true);
		return value;
	}

	render() {
		const { userList } = this.props.userContext;
		const { pagination } = this.props.commonContext;
		const { userModal, title, userDetails } = this.state;

		return (
			<div className='User'>
				<PageHeader
					title='User'
					btnText='User'
					onAdd={() => this.manageUser(true, 'add')}
					isToggle
					toggleValue={this.state.toggleView}
					onToggle={() => this.onToggle()}
				/>
				{this.state.toggleView ? (
					<UserTable
						userList={userList}
						manageUser={this.manageUser}
					/>
				) : (
						<UserList
							userList={userList}
							manageUser={this.manageUser}
						/>
					)}
				{pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				}
				{/* Add, Edit, and delete question_module */}
				{userModal &&
					<Modal
						modalOpen={userModal}
						toggleModal={this.manageUser}
						title={`${title} User`}
						disabled={title !== 'delete' && this.onDisable(this.state.errorUserDetails)}
						confirm={this.confirmUserAction}
					>
						<ManageUser
							isEdit={title === 'edit'}
							onDelete={title === 'delete'}
							userDetails={userDetails}
							onChange={(e, val) => this.onChange(e, val)}
						/>
					</Modal>
				}
				{/* Add, Edit, and delete question_module */}
			</div>
		);
	}
}


User.propTypes = {
	value: PropTypes.instanceOf(Object)
};

User.defaultProps = {
	value: {}
};

export default User;



// WEBPACK FOOTER //
// ./components/User/User.js